import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../constant/constant";
import {
  Box,
  Card,
  Typography,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Button,
  Stack,
  TextField,
  Divider,
  TableContainer,
  Paper,
} from "@mui/material";

import { Download, Print } from "@mui/icons-material";
import TrainIcon from "@mui/icons-material/Train";
import SchoolIcon from "@mui/icons-material/School";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

function SP_ActiveUsers() {
  const token = localStorage.getItem("token");
  const [activeUsers, setActiveUsers] = useState([]);
  const [search, setSearch] = useState("");

  // useEffect(() => {
  //   let ignore = false;

  //   const fetchActiveUsers = async () => {
  //     try {
  //       const res = await axios.get(`${API_BASE_URL}/api/activeuserlist` ,{headers: {
  //   'Content-Type': 'application/json',
  //    "Authorization": `Bearer ${token}`, // optional, set default headers
  // },});
  //       const data = res.data || [];
  //       if (!ignore && data.length > 0) setActiveUsers(data[0]);
  //     } catch (err) {
  //       console.error("Error fetching Active Users", err);
  //     }
  //   };

  //   fetchActiveUsers();
  //   const interval = setInterval(fetchActiveUsers, 5000);

  //   return () => {
  //     ignore = true;
  //     clearInterval(interval);
  //   };
  // }, []);

  // Search filter across name + email
 
 useEffect(() => {
  let ignore = false;

  const fetchActiveUsers = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/activeuserlist`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data || [];
      if (!ignore) setActiveUsers(data); // ✅ store array, not data[0]
    } catch (err) {
      console.error("Error fetching Active Users", err);
    }
  };

  fetchActiveUsers();

  return () => {
    ignore = true;
  };
}, [token]);

 
 
  const filteredUsers = activeUsers.filter(
    (user) =>
      user.name?.toLowerCase().includes(search.toLowerCase()) ||
      user.email?.toLowerCase().includes(search.toLowerCase())
  );

  // Group by softwaredetailsname
  const groupedUsers = filteredUsers.reduce((acc, user) => {
    const key = user.sofwaredetailsname || "Unknown";
    if (!acc[key]) acc[key] = [];
    acc[key].push(user);
    return acc;
  }, {});

  // Style + icon for groups
  const groupStyles = {
    rib: { color: "#b5de0eff", icon: <TrainIcon sx={{ mr: 1 }} /> },
    sch: { color: "#edb10cff", icon: <SchoolIcon sx={{ mr: 1 }} /> },
    med: { color: "#f59197ff", icon: <LocalHospitalIcon sx={{ mr: 1 }} /> },
  };

  return (
    <div>
      <Card sx={{ mt: 3, p: 2, borderRadius: 3, boxShadow: 3 }}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="h6">👨‍💻 Active Users</Typography>
          <TextField
            size="small"
            placeholder="Search user..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
        <Divider />

        {/* Table */}
        <Box sx={{ overflowX: "auto", fullWidth: true }}>
          <TableContainer component={Paper} sx={{ width: "100%" }}>
            <Table sx={{ minWidth: 650 }} aria-label="grouped users table">
              <TableBody>
                {Object.entries(groupedUsers).map(([softwareName, users]) => {
                  const softgroup = users?.[0]?.softgroup || "";
                  const { color, icon } = groupStyles[softgroup] || {};

                  return (
                    <React.Fragment key={softwareName}>
                      {/* Group Header */}
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          sx={{
                            backgroundColor: color || "#95a7ffff",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {icon}
                          {softwareName}
                        </TableCell>
                      </TableRow>

                      {/* Column Header */}
                      <TableRow sx={{ backgroundColor: "#eff1c9ff"}}>
                        <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                      </TableRow>

                      {/* Users */}
                      {users.map((user, i) => (
                        <TableRow key={i}>
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Avatar sx={{ mr: 2 }}>{user.name?.[0]}</Avatar>
                              {user.name}
                            </Box>
                          </TableCell>
                          <TableCell>{user.email}</TableCell>
                          <TableCell>
                            <Typography
                              sx={{
                                color:
                                  user.status === "Active" ? "red" : "green",
                                fontWeight: "bold",
                              }}
                            >
                              {user.status}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Action Buttons */}
        <Stack direction="row" spacing={2} mt={2}>
          <Button startIcon={<Download />} variant="outlined">
            Export
          </Button>
          <Button startIcon={<Print />} variant="outlined" color="secondary">
            Print
          </Button>
        </Stack>
      </Card>
    </div>
  );
}

export default SP_ActiveUsers;
